// extracted by mini-css-extract-plugin
export default {"root":"w7lz0","animationRun":"SobnD","favorite-success-action":"Q5ff5","animationClose":"fNjM3","favorite-close-action":"AffD3"};